import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Button, Menu, MenuItem } from 'react-aria-menubutton';

const Globals = require('../../../../app/globals');
const StringUtil = require('../../../../app/shared/StringUtil');

const propTypes = {
    id: PropTypes.string,
    selectedRoleToken: PropTypes.string,
    includeOwner: PropTypes.bool,
    includeGuest: PropTypes.bool,
    className: PropTypes.string,
    onRoleChange: PropTypes.func.isRequired
};

const defaultProps = {
    id: "org-member-role",
    roleToken: null,
    includeOwner: false,
    className: ""
};

class OrgRoleDropdown extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const self = this;

        const roleOptions = [
            {
                value: Globals.users.roles.ORG_MEMBER,
                content: StringUtil.getStringForRoleToken(Globals.users.roles.ORG_MEMBER)
            },
            {
                value: Globals.users.roles.ORG_PROJECT_CREATOR,
                content: StringUtil.getStringForRoleToken(Globals.users.roles.ORG_PROJECT_CREATOR),
            },
            {
                value: Globals.users.roles.ORG_VIEWER,
                content: StringUtil.getStringForRoleToken(Globals.users.roles.ORG_VIEWER),
            },
            {
                value: Globals.users.roles.ORG_SUPERVIEWER,
                content: StringUtil.getStringForRoleToken(Globals.users.roles.ORG_SUPERVIEWER),
            },
            {
                value: Globals.users.roles.ORG_ADMIN,
                content: StringUtil.getStringForRoleToken(Globals.users.roles.ORG_ADMIN),
            }
        ];

        if (this.props.includeOwner) {
            roleOptions.push({
                value: Globals.users.roles.ORG_OWNER,
                content: StringUtil.getStringForRoleToken(Globals.users.roles.ORG_OWNER),
            })
        }

        if (this.props.includeGuest) {
            roleOptions.unshift({
                value: Globals.users.roles.ORG_GUEST,
                content: StringUtil.getStringForRoleToken(Globals.users.roles.ORG_GUEST),
            });
        }

        let triggerContent = "Select a role...";

        const roleMenuItems = roleOptions.map((role) => {
            let itemClass = 'AriaMenuButton-menuItem';
            if(self.props.selectedRoleToken === role.value) {
                itemClass += ' is-selected';
                triggerContent = role.content;
            }

            return (
                <li className='AriaMenuButton-menuItemWrapper' key={role.value}>
                    <MenuItem
                    className={itemClass}
                    value={role.value}
                    text={role.content}>
                        {role.content}
                    </MenuItem>
                </li>
            );
        });

        return (
            <Wrapper
                id={this.props.id}
                className={'AriaMenuButton ' + this.props.className}
                onSelection={this.props.onRoleChange}
            >
                <Button className='AriaMenuButton-trigger'>
                    {triggerContent}
                </Button>
                <Menu>
                    <ul className='AriaMenuButton-menu'>
                        {roleMenuItems}
                    </ul>
                </Menu>
            </Wrapper>
        );
    }
}

OrgRoleDropdown.propTypes = propTypes;
OrgRoleDropdown.defaultProps = defaultProps;

export default OrgRoleDropdown;